import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal, Overlay, ScrollArea } from '@mantine/core';

import { useEditKeywordRule } from '../../api/editKeywordRule';
import { prophetTypes } from '../../types';
import { ChunkPlatform } from '../../utils/chunk-limits';

import { KeywordRuleForm } from './KeywordRuleForm/KeywordRuleForm';

export const EditModal = NiceModal.create(
  ({ rule, platform }: { rule: prophetTypes.KeywordRule; platform: ChunkPlatform }) => {
    const modal = useModal();

    const editKeywordRule = useEditKeywordRule({
      pageId: rule.page._id,
      config: { onSuccess: modal.hide },
    });

    return (
      <Modal
        title={rule.keyword || 'Стандартное правило'}
        centered
        overlayProps={{ opacity: 0.4, blur: 1.5 }}
        opened={modal.visible}
        onClose={modal.remove}
        closeOnEscape={!editKeywordRule.isLoading}
        closeOnClickOutside={!editKeywordRule.isLoading}
        withCloseButton={!editKeywordRule.isLoading}
        scrollAreaComponent={ScrollArea.Autosize}
      >
        {editKeywordRule.isLoading && <Overlay opacity={0} />}
        <KeywordRuleForm
          onSubmit={(data) => editKeywordRule.mutate({ ...data, _id: rule._id })}
          isLoading={editKeywordRule.isLoading}
          platform={platform}
          initialValues={{
            keyword: rule.keyword,
            messages: rule.messages,
          }}
        />
      </Modal>
    );
  }
);
